// extracted by mini-css-extract-plugin
export default {"height_h":"I5","half_width_elem":"J5","row":"K5"};
    if(module.hot) {
      // 1715091685668
      var cssReload = require("../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  